import { Component, inject, input, type OnInit, signal, ViewChild, viewChild } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { AdaaHelper } from "../../core/utils";
import { DataTableComponent } from "../../shared/components";
import { ReportGenerationComponent } from "../../shared/components/modals/report-generation/report-generation";
import { Constants } from "../../shared/constants/constants";
import { CustomButton } from "../../shared/models";
import { SystemLayoutService } from "../../shared/services";

@Component({
  selector: "adaa-reports",
  imports: [TranslatePipe, DataTableComponent, ReportGenerationComponent],
  templateUrl: "./reports.html",
  styleUrl: "./reports.scss",
})
export class ReportsComponent implements OnInit {
  private readonly _systemLayoutService = inject(SystemLayoutService);

  @ViewChild("reportGeneration") reportGeneration: ReportGenerationComponent;

  private readonly _untilDestroyed = AdaaHelper.untilDestroyed();

  tableConfList = input.required<string>();
  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");
  customButtons: CustomButton[] = [
    {
      iconName: "adaa-icon-settings",
      eventName: "settings",
      iconTitle: "tooltips.settings",
      showOnMobile: true,
    },
  ];
  Constants = Constants;

  showLoader = signal<boolean>(false);

  public ngOnInit() {
    this._systemLayoutService.hasCycleChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => this.adaaDataTable().loadTableData(true),
    });
    this._systemLayoutService.hasActiveEntityChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => {
        this.adaaDataTable().loadTableData(true);
        this.reportGeneration?._getOrgUnits(Number(AdaaHelper.entity?.id));
      },
    });
  }
}
